
import { defineComponent, defineEmits, ref } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";

export default defineComponent({
    name: "FormControl",
    components: {
        FormErrors,
        FormLabel
    },
    props: {
        id: {
            default: null,
            required: true,
            type: String
        },
        type: {
            default: 'text',
            required: false,
            type: String
        },
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: true,
            default: ""
        },
        value: {
            type: String,
            required: false,
            default: ""
        },
        changeValue: {
            type: Function,
            required: false,
            default: null
        }
    },
    setup(props, {emit}) {
        return {
            errors: [],
        }
    },
});
